import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import logo from "../../assets/yacht-mate-white-logo.png";

export const GeneralFooter = () => {
  const greenmateUrl = process.env.REACT_APP_YACHTMATE_URL;

  return (
    <Box className="footer">
      <Container maxWidth="lg">
        <Grid>
          <Grid item md={12}>
            <Link href={greenmateUrl}>
              <img alt="" src={logo} style={{ marginBottom: '20px', width:'250px' }} />
            </Link>
            <p style={{ margin: '0px' }}>© Copyright {new Date().getFullYear()} - Mooringmate. All Rights Reserved.</p>
            <div className="footer-link">
              {/* <Link href="/general">Complete intake</Link> */}
              {/* <Link href="/general">FAQ</Link> */}
              {/* <Link href="/general">Resources</Link> */}
              <Link href="/privacy-policy">Privacy Policy</Link>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
